import React from 'react';
import { Divider } from 'semantic-ui-react';
import propTypes from 'prop-types';
import CreateProvider from './store/CreateProvider';
import ContentWrapper from '../../../../template/Layout/ContentWrapper';
import Header from './components/Header';

// ? Actions imports
import ReportType from './app/ReportType';
import ReportConfig from './app/ReportConfig';
import ShareTo from './app/ShareTo';
import Scheduling from './app/Scheduling';
import ReportPreview from './app/ReportPreview';
import SaveReport from './app/SaveReport';
import { withNamespaces } from 'react-i18next';

function CreateAndEdit(props) {
  return (
    <CreateProvider>
      <ContentWrapper>
        {
          props.action === 'create' ?
            <div className="content-heading">
              <span className="fas fa-1x mr-2 fa-pencil-alt  classIconRepor" />
              {props.t("new_special_report")}
            </div>
            : ''
        }
        <div className='row' style={{ alignItems: "center" }}>
          <span className='icon-my-reports icons-front-module' />
          <span className='euro-title-form'>{props.t("type_report")}</span>
        </div>
        <div className='row' style={{ alignItems: "center", marginTop: "15px" }}>
          <ReportType />
          <SaveReport action={props.action} reportId={props.reportId} onEvent={props.onEvent} />
        </div>
        <Divider section />
        <ReportConfig />
        <ShareTo />
        <Scheduling />
        <Divider section />
        <div class="float-right" >
          <p className='text-mutedSeacargo'>{props.t("attention_limited_results")} </p>
        </div>
        {/* <br></br>
        <br></br>
        <br></br> */}
        <ReportPreview action={props.action} reportId={props.reportId} userId={Number(props._user)} rolId={Number(props._rolId)} />
      </ContentWrapper>
    </CreateProvider >
  );
}

CreateAndEdit.propTypes = {
  action: propTypes.string,
  reportId: propTypes.number,
};
CreateAndEdit.defaultProps = {
  action: 'create',
  reportId: 0
};

export default withNamespaces()(CreateAndEdit);